/* eslint-disable */
interface PendingNotification {
	planNames: string[];
	receivedAt: number;
}

let pendingNotification: PendingNotification | null = null;
const listeners: Array<(notification: PendingNotification) => void> = [];

export const enrollmentNotificationStore = {
	// Called from App.tsx socket handler
	setPending: (planNames: string[]) => {
		pendingNotification = { planNames, receivedAt: Date.now() };
		// Notify any active listeners (if VEB page is open)
		listeners.forEach((fn) => fn(pendingNotification!));
	},

	// Called from useVEBEnrollmentData on mount — gets missed notification
	getPending: (): PendingNotification | null => {
		return pendingNotification;
	},

	// Called after modal is shown
	clear: () => {
		pendingNotification = null;
	},

	// Subscribe to live notifications (when VEB page is open)
	subscribe: (fn: (n: PendingNotification) => void) => {
		listeners.push(fn);
		return () => {
			const idx = listeners.indexOf(fn);
			if (idx > -1) listeners.splice(idx, 1);
		};
	}
};
